var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import UpperSupCheckService from '../../api/UpperSupCheckService';
import LicenseService from '../../api/LicenseService';
import _ from 'lodash';
import EAccountType from '../../enum/EUpperSupAccountType';
import GLOBAL_VUE from '../../globalVue';
import { add, numSub } from '../../helper/calucate';
import { UpperSupCheckRefresh } from '../../constant/eventKey';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from 'element-ui';
var orderTypeList = [
    {
        id: "1",
        name: "采购入库单"
    },
    {
        id: "2",
        name: "采购退货单"
    },
    {
        id: '6',
        name: '费用单'
    }
];
var minuteFlag = "扣款";
function summaries(param, showItems) {
    var columns = param.columns, data = param.data;
    var sums = [];
    columns.forEach(function (column, index) {
        if (index === 0) {
            sums[index] = '合计';
            return;
        }
        var showSum = showItems;
        if (showSum.indexOf(column.property) != -1) {
            var filter_1 = function (item) { return item.fee_direction_name === minuteFlag ? -item[column.property] : item[column.property]; };
            var fn = function (data) { return _.map(data, filter_1); };
            sums[index] = _.flowRight(add, fn)(data).toFixedNoZero(4);
        }
        else {
            sums[index] = '';
        }
    });
    return sums;
}
var Add = (function (_super) {
    __extends(Add, _super);
    function Add() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyInfo = {};
        _this.handleType = "";
        _this.orderDetail = {
            order_types: orderTypeList.map(function (item) { return item.id; }),
            depot_ids: [-1]
        };
        _this.depotOptions = [];
        _this.eAccountType = EAccountType;
        _this.orderTypeList = orderTypeList;
        _this.tabelHeight = document.documentElement.clientHeight - 410;
        _this.selection = [];
        return _this;
    }
    Add.prototype.getSummaries = function (param) {
        param.data = this.selection;
        var showSum = ["money", "order_tax_money"];
        if (param.columns && param.columns.length) {
            param.columns[0].colSpan = 1;
        }
        var data = summaries(param, showSum);
        var total_order_money = this.orderDetail.total_order_money =
            (this.selection).reduce(function (ori, item) {
                return item.fee_direction_name === minuteFlag ? add(ori, -item.order_money) : add(ori, item.order_money);
            }, 0);
        data[2] = "应付合计：" + total_order_money;
        this.calcOrderPaymentMoney();
        return data;
    };
    Add.prototype.arraySpanMethod = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        if (rowIndex === (this.orderDetail.order_list || []).length && columnIndex === 0) {
            return [1, 2];
        }
        return [1, 1];
    };
    Add.prototype.calcOrderPaymentMoney = function () {
        var total_discount_money = this.orderDetail.total_discount_money ? this.orderDetail.total_discount_money : 0;
        this.orderDetail.order_payment_money = numSub(this.orderDetail.total_order_money, total_discount_money);
    };
    Add.prototype.discountChange = function () {
        this.calcOrderPaymentMoney();
    };
    Add.prototype.typeChange = function () {
        this.createAddInfo();
    };
    Add.prototype.depotIdsChange = function () {
        this.createAddInfo();
    };
    Add.prototype.save = function () {
        var _this = this;
        var saveParamsFields = [
            "supplier_upper_id",
            "account_date_start",
            "account_date_end",
            "statement_type",
            "depot_id",
            "organ_id",
            "depot_ids",
            "total_discount_money",
            "discount",
            "order_icomment",
        ];
        var params = __assign({}, _.pick(this.orderDetail, saveParamsFields));
        params.other_order_ids = this.selection.map(function (item) { return item.order_id; });
        params.order_types = this.orderDetail.order_types.join(',');
        if (this.handleType !== 'edit') {
            params.depot_ids = ((this.orderDetail.depot_ids).filter(function (item) { return item !== -1; })).join(',');
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        if (this.handleType === 'edit') {
            params.order_id = this.orderDetail.order_id;
            this.service.update(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg);
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 1000);
                window._czc.push(["_trackEvent", '供应商对账单', '编辑对账单']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            this.service.create(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg);
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                        GLOBAL_VUE.$emit(UpperSupCheckRefresh);
                    }
                }, 1000);
                window._czc.push(["_trackEvent", '供应商对账单', '添加对账单']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    Add.prototype.getDepotOptions = function () {
        var _this = this;
        var paramsFields = [
            "supplier_upper_id",
            "account_date_start",
            "account_date_end",
            "statement_type",
            "organ_id"
        ];
        this.service.getDepotOptions(__assign({}, _.pick(this.detail, paramsFields))).then(function (res) {
            var data = res.data.data;
            data.unshift({
                depot_id: -1,
                depot_name: "所有仓库"
            });
            _this.depotOptions = data;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Add.prototype.createAddInfo = function () {
        var _this = this;
        var addParamsFields = [
            "supplier_upper_id",
            "account_date_start",
            "account_date_end",
            "statement_type",
        ];
        if (this.detail.statement_type == EAccountType.MulOrgan) {
            addParamsFields.push("organ_id");
        }
        else if (this.detail.statement_type == EAccountType.MulDepto) {
            addParamsFields.push("depot_id");
        }
        else {
        }
        var params = __assign({ order_types: this.orderDetail.order_types.join(",") }, _.pick(this.detail, addParamsFields));
        if (!this.orderDetail.depot_ids.some(function (item) { return item === -1; })) {
            params.depot_ids = this.orderDetail.depot_ids.join(',');
        }
        this.service.createAddInfo(params).then(function (res) {
            var data = res.data.data;
            var old_depot_ids = _this.orderDetail.depot_ids;
            _this.orderDetail = __assign({}, _this.detail, _this.orderDetail, data);
            _this.orderDetail.depot_ids = old_depot_ids;
            _this.tabelHeight++;
            setTimeout(function () {
                _this.$refs.table.toggleAllSelection(true);
            }, 0);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Add.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetail({
            order_id: this.detail.order_id
        }).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.orderDetail = data;
            _this.tabelHeight++;
            setTimeout(function () {
                _this.$refs.table.toggleAllSelection(true);
            }, 0);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Add.prototype.selectionChange = function (selection) {
        this.selection = selection;
    };
    Add.prototype.getCompanyInfo = function () {
        var _this = this;
        this.licenseService.getCompanyInfo().then(function (res) {
            if (res.data.success) {
                _this.companyInfo = res.data.data;
            }
        });
    };
    Add.prototype.mounted = function () {
        if (this.handleType === 'edit') {
            this.getDetail();
        }
        else {
            this.getDepotOptions();
            this.createAddInfo();
        }
    };
    Add.prototype.created = function () {
        this.service = UpperSupCheckService.getInstance();
        this.licenseService = LicenseService.getInstance();
        this.getCompanyInfo();
    };
    Add = __decorate([
        auth(nameDict["供应商对账单"], true),
        Component({})
    ], Add);
    return Add;
}(Vue));
export default Add;
